import React, { Component } from 'react';
import {
  Container,
  Header,
  Icon,
  Image,
  Button,
  Form,
  Modal,
  Card
} from 'semantic-ui-react';
import './home.css';
import { createservice } from '../../services/crudservice';
class motdModal extends Component {
  constructor() {
    super();

    this.state = {
      src: 'http://via.placeholder.com/350x350?text=Sample',
      title: 'Sample Header',
      message: ''
    };
  }
  genHeader() {
    if (this.props.mobile != true) {
      return (
        <Header as="h3">
          <Icon color="grey" name="comment outline" />
          Message of The Day
        </Header>
      );
    }
  }

  render() {
    console.log('motd Modal', this.props.open ? 'open' : 'closed');
    return (
      <Modal
        size={'large'}
        open={this.props.open}
        onClose={() => this.props.close()}
      >
        <Modal.Header>Create Message Of The Day</Modal.Header>
        <Modal.Content>
          <Card>
            <Container>
              <h4>{this.state.title}</h4>
              <Image src={this.state.src} id="motdModalCard" />
              <p>{this.state.message}</p>
            </Container>
          </Card>
          <Form>
            <Form.Input
              label="Title"
              value={this.state.title}
              onChange={e => {
                this.setState({ title: e.target.value });
              }}
            />
            <Form.Input
              label="Image Source"
              value={this.state.src}
              onChange={e => {
                this.setState({ src: e.target.value });
              }}
            />
            <Form.TextArea
              label="Message"
              value={this.state.message}
              onChange={e => {
                this.setState({ message: e.target.value });
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            positive
            icon="checkmark"
            labelPosition="right"
            content="Create"
            onClick={() => {
              let motd = {
                ...this.state,
                createdby:
                  this.props.myinfo.firstname + ' ' + this.props.myinfo.lastname
              };
              createservice('motd', motd, 'Message of the Day').then(() =>
                this.props.reloadmotd()
              );
              this.props.close();
            }}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}
export default motdModal;



// WEBPACK FOOTER //
// ./src/components/home-components/motdModal.js